/* eslint-disable no-use-before-define */
import React from 'react'
import { format, showBondOrder, showModal } from '../../twd'

export default ({rows}) => {

   return <div className="table-responsive">
    <table
        data-name='municipals-ticker-table'
        className="table table-hover align-top table-striped">
        <thead>
        <tr>
        <th>Date</th>
        <th>Trade</th>
        <th width="30%">Issuer</th>
        <th className="text-right">State</th>
        <th className="text-right">Coupon</th>
        <th className="text-right">Maturity</th>
        <th className="text-right">Price/Yield</th>
        <th className="text-right">Actions</th>
        </tr>
    </thead>
    <tbody>
        {
            rows.map( (r,i) => {
                var ts = new Date(r.tradeDate)
                if (isNaN(ts.valueOf())) ts = null
                let [dt, ...tm] = ts
                    ? r.tradeDate.split(' ')
                    : ['',[]]

                return <tr key={i}>
                    <td>{dt}<br/>{tm.join(' ')}</td>
                    <td>{format.qty(r.trade)}</td>
                    <td className="text-bold">{format.issuer({
                        issuer:r.issue,
                        cusip:r.cusip,
                        from:'municipals/municipal-ticker',
                        className:'link-button text-left'
                    })}</td>
                    <td className="text-right">{r.state}</td>
                    <td className="text-right">{format.cpn(r.coupon)}</td>
                    <td className="text-right">{format.mdy(new Date(r.maturity))}</td>
                    <td className="text-right" style={{whiteSpace:'nowrap'}}>{format.price(r.price)} / {format.ytw(r.yield)}</td>
                    <td className="text-center">
                        { r.tradeHistory && <TradeHistoryButton cusip={r.cusip} />}
                        { r.buyAction && <BuyButton cusip={r.cusip} />}
                    </td>
                </tr>

            })
        }
    </tbody>
    </table>
    </div>
}

const TradeHistoryButton = ({cusip}) => {
    return <button
    type="button"
    data-name="municipals-ticker-trade-history-button"
    className="btn btn-block btn-sm btn-primary-outline vertical-offset-xxs"
    onClick={(e) => {
        let p = {
            view: 'trade-history',
            cusip,
            source: e.target,
        }
        showModal(p)
    }}
    >Trade history</button>
}

const BuyButton = ({cusip}) => {
    return <button
        type="button"
        data-name="municipals-ticker-buybutton"
        className="btn btn-block btn-sm btn-primary"
        onClick={() => {
            showBondOrder({
                cusip,
                action: 'B',
                from: 'municipals/municipal-ticker'
            })
        }}
        >Buy</button>

}